import React, { Component } from "react";
import ArticleComments from "./ArticleComments"
import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';

class Friday1 extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }

    var answerStyle = {
      fontSize:16
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>Friday Night Blitz 1: Tournament Recap</h1>

          <p style={size13}>
            By: Psynight - March 31, 2018
          </p>

          <img src={"../ArticleImages/Frenzy310x180.jpg"} style={imgCenterStyle} className="img-fluid" id="frenzy" alt="frenzy" />
          <p style={answerStyle}>
          Our first tournament is in the books.  We had 4 players participate which
          gave it the local card shop feel that I was expecting.
          </p>
          <p style={answerStyle}>
          The players were Uni, Psynight (myself), Daidairow and Supremes.
          </p>

          <ul>
            <li>Uni brought <Link to={routes.DECKVIEW + "ywJImNexRzMaLHlv8euc"}>"chaos / nature"</Link></li>
            <li>Psynight brought <Link to={routes.DECKVIEW + "tTOuOCLlEWa0NLiL7Fa9"}>"Nature Ninjas"</Link></li>
            <li>Daidairow brought <Link to={routes.DECKVIEW + "5NO1mIfAsUsdHbzhj182"}>"control egg"</Link></li>
            <li>Supremes brought <Link to={routes.DECKVIEW + "uB9XDMZb6JqiWNrnmfz9"}>"Blood Judgment (Medium Expense)"</Link></li>
          </ul>

          <h5> Round 1 </h5>
          <p>
            {"I wound up playing Uni in the first round. The first game started with Uni flooding the board with goblins and me thinking to myself I didn't think people still played aggro.  A turn 5 suprise attack sealed that game up pretty quickly."}
          </p>
          <p>
          {"The second game Uni didn't play anything the first 4 rounds, I was beginning to wonder if he remembered that we were supposed to play the same deck.  That or he just felt bad for stomping me so quickly in the first game.  By the time he was able to play some cards it was too little to late."}
          </p>
          <p style={answerStyle}>
          {"Which basically sums up the last game.  Uni didn't come out with the blazing speed of the first game but his deck did allow for a balanced beginning with a brutal end game."}
          </p>
          <p style={answerStyle}>
          {"Uni's deck was really interesting, a strong early game, decent mid and late creatures with a bag of tricks like Surprise Attack, I Got a Rock and Timestop to keep your opponent on their toes.  All in all and interesting deck and a well deserved first round win on Uni's part."}
          </p>
          <p style={answerStyle}>
          {"Of note not that I think it would've changed much based on how the games played out I didn't see a single Kenji all three games."}
          </p>
          <h5> Round 2 </h5>
          <p style={answerStyle}>
          {"Next up was Surpremes.  Unfortunately for him my lack of Kenji's in the first round was made up for in the next two games. In both games I was able to get a swarm of Kenji's built up and basically flood the board.  I don't remember getting many buffs on them but I do remember playing A LOT of them."}
          </p>
          <p style={answerStyle}>
          {"Unfortunately I do not think I was able to see Surpremes deck in it's full capacity so I cannot really comment on it."}
          </p>
          <h5> Round 3 </h5>
          <p style={answerStyle}>
          {"Last round I was up against Daidairow.  He was playing an Egg Kaiju deck.  Despite being currently popular I had not come up against one of these decks during ladder play.  I was a bit shocked to see Kaiju has Evade, let alone Overrun and Regenerate."}
          </p>
          <p style={answerStyle}>
          {"Fortunately in the first game I was able to get an early start of Kenji's and Verdant Druid so when the Kaiju landed I was able to finish the game before the Kaiju was able to attack more than once."}
          </p>
          <p style={answerStyle}>
          {"The second game I kept a Murder in my opening hand.  I had a Tangle as well so was able to kill the Kaiju when it showed up.  I was able to end the game fairly quickly after that.  In both games Daidairow was able to get the Egg down by turn 3 or 4 so that was a pretty consistent."}
          </p>
          <h5>Results and Final Thoughts</h5>
          <p style={answerStyle}>
          {"Uni was able to sweep both his round 2 and 3 so was crowned our Champ. I wound up in second which I was pretty happy with, the Nature Ninjas deck is one of my favorites.  I'm looking forward to next week.  I've already had more people reach out expressing interest in playing.  So make sure to let the people on your friend's list know about it. Spread the word, more good times ahead."}
          </p>
        </div>
          <ArticleComments articleId={"7"} />
      </div>


    );
  }
}

export default Friday1;



// WEBPACK FOOTER //
// ./src/Articles/Friday1.js